import { GridColumn } from 'types/grid';
import { ModalListData } from 'types/modal';
import { ListType } from 'types/selectbox';
import { ScheduleItem, ScheduleSearchResponse } from './type';
import { scheduleStatus, cancelStatus } from 'utils/statusDefinitions';

// 스케줄 그리드 데이터 타입
interface ScheduleGridData {
  scheduleId: number;
  memberId: number;
  email: string;
  tleTitle: string;
  groundStationName: string;
  startTime: string;
  endTime: string;
  reservationDate: string;
  status: string;
  cancelStatus: string;
  cancelable: boolean;
  name: string;
}

// 스케줄 그리드 리스트
export const scheduleGridColumns = [
  { title: 'TLE Title', key: 'tleTitle', width: 150 },
  { title: 'Ground Station', key: 'groundStationName', width: 180 },
  { title: 'AOS', key: 'startTime', width: 180 },
  { title: 'LOS', key: 'endTime', width: 180 },
  { title: 'Status', key: 'status', width: 120 },
  { title: 'Email', key: 'email', width: 200 },
  { title: 'Reservation Date', key: 'reservationDate', width: 180 },
  { title: 'Cancel', key: 'cancel', width: 100 },
  { title: 'Cancel Status', key: 'cancelStatus', width: 140 }
];

// 스케줄 상세보기
export const scheduleModalList: ModalListData[] = [
  { title: 'Schedule ID', key: 'scheduleId' },
  { title: 'Member ID', key: 'memberId' },
  { title: 'Email', key: 'email' },
  { title: 'TLE Title', key: 'tleTitle' },
  { title: 'Ground Station', key: 'groundStationName' },
  { title: 'Start Time', key: 'startTime' },
  { title: 'End Time', key: 'endTime' },
  { title: 'Reservation Date', key: 'reservationDate' },
  { title: 'Status', key: 'status' },
  { title: 'Cancel Status', key: 'cancelStatus' },
  { title: 'Cancelable', key: 'cancelable' }
];

// 스케줄 상태 리스트 (백엔드 Enum 순서에 맞게 수정)
export const statusList = [
  { value: 1, label: 'IDLE' },
  { value: 2, label: 'SCHEDULED' },
  { value: 3, label: 'PROCESS' },
  { value: 4, label: 'COMPLETE' },
  { value: 5, label: 'FAIL' },
  // { value: 6, label: 'CANCEL' } 제거됨
];

// number value를 status string으로 변환하는 매핑 (백엔드 Enum 순서에 맞게 수정)
export const statusValueToStatus = (value: number): string => {
  const statusMap: Record<number, string> = {
    1: 'IDLE',
    2: 'SCHEDULED',
    3: 'PROCESS',
    4: 'COMPLETE',
    5: 'FAIL',
    6: 'CANCEL'
  };
  return statusMap[value] || 'IDLE';
};

// status string을 number value로 변환하는 매핑 (백엔드 Enum 순서에 맞게 수정)
// export const statusToStatusValue = (status: string): number => {
//   const valueMap: Record<string, number> = {
//     'IDLE': 1,
//     'SCHEDULED': 2,
//     'PROCESS': 3,
//     'COMPLETE': 4,
//     'FAIL': 5,
//     'CANCEL': 6,
//     // 기존 값들과의 호환성 유지
//     'IN_PROGRESS': 3, // Maps to PROCESS
//     'COMPLETED': 4,   // Maps to COMPLETE
//     'CANCELLED': 6,   // Maps to CANCEL
//     'FAILED': 5       // Maps to FAIL
//   };
//   return valueMap[status] || 1;
// };

// 공통 status 정의들을 export
export { scheduleStatus as status, cancelStatus };

